import React from "react";
import PropTypes from "prop-types";
import { isFunction, isObject, isString } from "../../lib/utils";
import Tooltip from "../tooltip/tooltip";

const SelectionInput = ({ children, getSelectionInputTooltip, rowData }) => {
  let tooltip = null;

  if (isFunction(getSelectionInputTooltip)) {
    const checkboxInfo = getSelectionInputTooltip(rowData);

    if (isString(checkboxInfo)) {
      tooltip = { text: checkboxInfo };
    } else if (isObject(checkboxInfo) && checkboxInfo.text) {
      tooltip = checkboxInfo;
    }
  }

  return tooltip ? <Tooltip {...tooltip}>{children}</Tooltip> : children;
};

SelectionInput.propTypes = {
  getSelectionInputTooltip: PropTypes.func,
  children: PropTypes.node,
  rowData: PropTypes.object
};

export default SelectionInput;
